<template>
    <div v-if="hasErrors" class="invalid-feedback d-block">
        <p v-for="(error, i) in messages" :key="i">
            {{ error }}
        </p>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: ['attribute', 'errors'],
    computed: {
        hasErrors () {
            return this.messages.length > 0
        },
        messages () {
            return _.get(this.errors, this.attribute, [])
        },

    }
}
</script>
